export default "__VITE_ASSET__CcQw8R7L__"